module.exports = __webpack_public_path__ + "img/project_info.4a9800a1.svg";